angular
    .module('empower.uploadDocument')
    .service('uploadDocumentService', ['$q', 'httpService', '$rootScope', '$filter', 'commonConst',
        function ($q, httpService, $rootScope, $filter, commonConst) {
            return {
                getDocumentUploadHistory: getDocumentUploadHistory,
                saveDocumentUploadInfo: saveDocumentUploadInfo
            };

            function getDocumentUploadHistory(params) {
                var def = $q.defer(),
                    APITarget = 'api/vicupload/getvicuploadhistory',
                    Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: params.PolicyId,
                        ClaimId: params.ClaimId,
                        IsClaimant: $rootScope.user.IsClaimant,
                        RowsPerPage: params.RowsPerPage || commonConst.ROWS_PER_PAGE,
                        PageNumber: params.PageNumber || 1,
                    });

                httpService.httpRequest(APITarget, Values).then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            } // getDocumentUploadHistory

            // after upload document in server, save that info into db and send email
            function saveDocumentUploadInfo(params) {
                var def = $q.defer(),
                    APITarget = 'api/file/uploaddone',
                    Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        IsClaimant: $rootScope.user.IsClaimant,
                        DateOfBirth: $rootScope.user.DateOfBirth,
                        UploadUserId: $filter('decstr64')(sessionStorage.UserId),
                        UploadSession: params.UploadSession,
                        DocumentType: params.DocumentType,
                        PolicyId: params.PolicyId,
                        ClaimId: params.Claim ? params.Claim.ClaimId : null,
                        ClaimNumber: params.Claim ? params.Claim.ClaimNumber : '',
                        ClaimantName: params.Claim ? params.Claim.WorkerName : '',
                        Comment: params.Comment,
                        TravelDate: params.TravelDate,
                        TravelForm: params.TravelForm,
                        TravelTo: params.TravelTo,
                        DoctorName: params.DoctorName,
                        TravelType: params.TravelType,
                        TravelCost: params.TravelCost,
                    });

                httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            } // saveDocumentUploadInfo
        }
    ]);